import Vue from 'vue'
import axios from 'axios'
import { Dialog } from 'vant'
import store from '@/store'
import { VueAxios } from './axios'
import { Tip } from '@/utils'
import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
import { login } from "@/utils/login"

Vue.use(Dialog)

import {
  apiBaseUrl,
  apiBaseUrlLogin,
  apiBaseUrlUpload,
  apiBaseUrlDownload,
  apiContactAvatar
} from '@/config/apiConfig'

const service = axios.create({
  baseURL: apiBaseUrl,
  timeout: 30000
})

const handleError = (error) => {
  if (error.response) {
    const { data } = error.response
    const token = Vue.ls.get(ACCESS_TOKEN)

    if (error.response.status === 200) {
      console.log('code为 200 ')
    } else if (data.message.includes('Token失效')) {
      login()
        .then(() => window.location.reload())
        .catch((e) => {
          if (e && e.rejectType === 'browser') {
            store.dispatch('Logout').then(() => {
              Vue.ls.remove(ACCESS_TOKEN)
              window.location.reload()
            })
          }
        })
    } else {
      Tip.error(data.message)
    }
    return
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  let prefix = store.state.user.currentPrefix || '/jksaas-produce/produce'

  if (config.url.includes("/jksaas-produce/produce")) {
    prefix = ""
  }

  const suffixPath = config.url
  const slash = config.url.charAt(0) === '/'
  config.url = `${apiBaseUrl}${prefix}${slash ? config.url : '/' + config.url}`
  if (config.url.indexOf('jksaas-mgt/mgt') !== -1) {
    config.url = config.url.replace("/jksaas-produce/produce", "")
  } else {
    config.url = config.url
  }

  const specialEndpoints = new Set(['phoneLogin', 'logout', 'queryMyself', 'getDepartAndUserByDepartId', 'getUserPersonInfo', 'getRoute', 'getUserPermissionByToken', 'getAppPermission', 'getReportList'])
  const excludedSysPaths = new Set(['dict', 'sysEntityProc', 'category', 'common', 'duplicate', 'getFileListByIds'])

  if (
    specialEndpoints.has(config.url.split('/').pop()) ||
    (suffixPath.split('/')[1] === 'sys' && !excludedSysPaths.has(suffixPath.split('/')[2]))
  ) {
    config.url = `${apiBaseUrlLogin}/jksaas-mgt/mgt${suffixPath}`
    const systemTypeParam = { systemType: '1' }
    if (config.method === 'get') {
      config.params = { ...config.params, ...systemTypeParam }
    }

    if (config.url.includes('home/update')) {
      delete config.data.systemType
    } else if (config.url.includes('getFileListByIds')) {
      config.url = `${apiBaseUrl}/${suffixPath}`
    }
  }

  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['X-Access-Token'] = token
  }

  const tenantid = Vue.ls.get(TENANT_ID) || 0
  config.headers['tenant_id'] = tenantid

  if (config.method === 'get' && !config.url.includes('sys/dict/getDictItems')) {
    config.params = {
      // _t: Date.now() / 1000,
      ...config.params
    }
  }
  return config
}, error => Promise.reject(error))

// response interceptor
service.interceptors.response.use(response => response.data, handleError)

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

/**
 * Blob解析
 * @param data
 */
function blobToJson(data) {
  const fileReader = new FileReader()
  const token = Vue.ls.get(ACCESS_TOKEN)
  fileReader.onload = function () {
    try {
      const jsonData = JSON.parse(this.result)
      console.log('jsonData', jsonData)
      if (jsonData.status === 500 && token && jsonData.message.includes('Token失效')) {
        store.dispatch('Logout').then(() => {
          Vue.ls.remove(ACCESS_TOKEN)
          window.location.reload()
        })
      }
    } catch (err) {
      console.log('blob解析fileReader返回err', err)
    }
  }
  fileReader.readAsText(data)
}

export {
  installer as VueAxios,
  service as axios,
  apiBaseUrl,
  apiBaseUrlUpload,
  apiBaseUrlDownload,
  apiContactAvatar
}
